import React, { useEffect, useRef, useState } from 'react';
import SelectForm from './SelectForm';
import EventForm from './EventForm';
import CheckOutForm from './CheckOutForm.js';

export default function EventSubmit() {
  const eventForm = useRef(null);
  const [formType, setFormType] = useState('');
  const [paidFormIsValid, setPaidFormValid] = useState(false);
  const [paidPlan, setPaidPlan] = useState('');
  const [coupon, setCoupon] = useState('');
  const [formData, setFormData] = useState({});

  useEffect(() => {
    formType.length > 0
      ? window.scrollTo({
          top: eventForm.current.offsetTop - 150,
          behavior: 'smooth'
        })
      : '';
  }, [formType]);

  return (
    <div className="event-submit">
      <SelectForm setFormType={setFormType} formType={formType} />
      <div ref={eventForm}>
        {formType && (
          <EventForm
            paidPlan={paidPlan}
            setPaidPlan={setPaidPlan}
            setFormType={setFormType}
            formType={formType}
            setCoupon={setCoupon}
            paidFormIsValid={paidFormIsValid}
            setPaidFormValid={setPaidFormValid}
            setFormData={setFormData}
          />
        )}
      </div>
      {paidFormIsValid && formType === 'paid' && (
        <CheckOutForm paidPlan={paidPlan} coupon={coupon} formData={formData} />
      )}
    </div>
  );
}
